import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgHydrocortisoneGlyph(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 23.02 17 10l15.8 1.05 6.9 14.48-8.95 13.15-15.94-1.23L8 23.02Zm7.66 13.26 14.52 1.12 8.15-11.98-6.28-13.18-14.39-.96-8.2 11.86 6.2 13.14Zm7.52-13.81-1.22-.25.54-2.63-2.65-.54-.54 2.63-1.21-.25 1.26-6.17 1.21.25-.49 2.41 2.65.54.49-2.41 1.22.25-1.26 6.17Zm6.39-3.05 1.33.27c-.07-1.31-.83-2.37-2.4-2.69-1.81-.36-3.37.72-3.74 2.57-.38 1.85.62 3.47 2.44 3.84 1.58.32 2.68-.31 3.29-1.58l-1.28-.26c-.33.55-.91.89-1.78.71-1.1-.23-1.66-1.26-1.41-2.46.25-1.19 1.16-1.91 2.25-1.69.83.17 1.2.64 1.3 1.29ZM18.06 30.87c-1.79 0-3.25-1.44-3.25-3.21s1.46-3.21 3.25-3.21 3.25 1.44 3.25 3.21-1.46 3.21-3.25 3.21Zm0-5.18c-1.1 0-2 .88-2 1.96s.9 1.96 2 1.96 2-.88 2-1.96-.9-1.96-2-1.96Zm7.16 7.71.38.49 7.28-5.68-.38-.49c-1.55-1.97-4.43-2.31-6.44-.75-2.01 1.57-2.38 4.45-.84 6.43Zm1.6-5.44c.62-.49 1.35-.72 2.08-.72.79 0 1.56.27 2.17.8l-5.21 4.06c-.7-1.38-.33-3.13.96-4.14Z",
    fill: "currentColor"
  }));
}

export { SvgHydrocortisoneGlyph as default };
